// extracted by mini-css-extract-plugin
export var root = "about-module--root--YGHWu";
export var navContainer = "about-module--navContainer--2HkeB";
export var detailContainer = "about-module--detailContainer--n9Pq6";
export var imageContainer = "about-module--imageContainer--QtEJB";
export var content = "about-module--content--omyyq";